import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { SHARED_IMPORTS } from "src/app/shared/standalone-imports";

@Component({
  selector: "no-recording-card",
  templateUrl: "./no-recording.component.html",
  styleUrls: ["./recording.component.css"],
  imports: SHARED_IMPORTS,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoRecordingComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
  }
}
